import type {ConnectElementConfig} from '../ConnectElementList';

export const treasuryEntryBannerIsVisibleParameter = 'visible' as const;

export const treasuryEntryBannerOnboardingRequiredParameter =
  'onboarding-required' as const;

// The host gates visibility on active capabilities. Only active Issuing is
// needed here to select the card task and artwork.
export const treasuryEntryBannerIssuingActiveParameter =
  'issuing-active' as const;
export const treasuryEntryBannerCompletedTasksParameter =
  'completed-tasks' as const;

export const TreasuryEntryBannerConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryEntryBanner" */
      '../../../components/MoneyManagement/TreasuryEntryBanner/TreasuryEntryBanner'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  htmlAttributes: {
    [treasuryEntryBannerIssuingActiveParameter]: {isInternal: true},
    [treasuryEntryBannerCompletedTasksParameter]: {isInternal: true},
    [treasuryEntryBannerOnboardingRequiredParameter]: {isInternal: true},
    [treasuryEntryBannerIsVisibleParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: [
    'close',
    'treasuryentryctaclick',
    'onboardingexited',
    'treasuryentrytaskclick',
  ],
  customHtmlElementMethods: {
    setIssuingActive: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryBannerIssuingActiveParameter,
      isInternal: true,
      description:
        'Whether Issuing capabilities are active; includes the card task and artwork.',
    },
    setCompletedTasks: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryBannerCompletedTasksParameter,
      isInternal: true,
      description:
        'Replaces the completed task list with comma-separated IDs: create-card, view-account, create-account, upload-bill. Shows the completed banner when all displayed tasks are complete.',
    },
    setOnTaskClick: {
      type: 'EventListenerMethod',
      event: 'treasuryentrytaskclick',
      isInternal: true,
      description:
        'Called with {task} for host navigation. Clicking a task does not mark it completed.',
    },
    setOnboardingRequired: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryBannerOnboardingRequiredParameter,
      isInternal: true,
      description:
        'Sets whether banner CTAs continue into financial account onboarding.',
    },
    setOnOnboardingStart: {
      type: 'EventListenerMethod',
      event: 'treasuryentryctaclick',
      isInternal: true,
      description: 'Called when the user opens financial account onboarding.',
    },
    setOnOnboardingExit: {
      type: 'EventListenerMethod',
      event: 'onboardingexited',
      isInternal: true,
      description:
        'Called when onboarding exits so the host can refresh account state.',
    },
    setIsVisible: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryBannerIsVisibleParameter,
      isInternal: true,
      description: 'Sets whether the Treasury entry banner is visible.',
    },
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: true,
      description:
        'Called in every banner state on dismissal. The host must persist this per user with one state-independent dismissible key and set visibility to false on future visits.',
    },
  },
  description: 'Internal dismissible banner for EFS test accounts.',
  friendlyName: 'Treasury Entry Banner',
};
